// extracted by mini-css-extract-plugin
export default {"playerResource":"KPlayerResourceItem-module__playerResource--KDUIw"};